const dynamicPackage = {
  detailedPlan: "Detaillierter Plan", // translated
  minimum: "Minimum", // translated
  maximum: "Maximal", // translated
};

export default dynamicPackage;
